import { mapActions, mapState, mapGetters } from 'vuex';
import { gConsts } from '@/globals/gConsts';
import { utils   } from '@/globals/utils';
import _ from 'lodash';
import { evtBus  } from '@/main';
    
export const paths = {

    data () {
        return {
        }
    },

    // =========================================================================================

    computed: {
        ...mapState({
//            rtMov : state => state.runtime.mov,  // posso usar mapState pq só uso os valores em [methods]
        }),

        ...mapGetters([
            'GET_waZoomScale',
        ]),
    },

    // =========================================================================================

    methods: {
        ...mapActions([
            'ACT_toolUpdate',
            'ACT_toolAddPts',
            'ACT_toolDelPts',
            'ACT_runtimeUpdate',
        ]),

        // -----------------------------------------------------------------

        d_path(forceClose) {
            var idx, dStr,
                pts  = this.tool.coords.pts;

            dStr = 'M ' + pts[0].x + ' ' + pts[0].y;            
            for (idx = 1; idx < pts.length; idx++) {
                dStr += ' L ' + pts[idx].x + ' ' + pts[idx].y
            }

            return this.closePath(dStr, forceClose);
        },


        // -----------------------------------------------------------------

        /* 
            ref: https://stackoverflow.com/questions/62855310/converting-a-list-of-points-to-an-svg-cubic-piecewise-bezier-curve
            ref2 (parece interessante se nao for mto parecido) : https://stackoverflow.com/questions/15691499/how-do-i-draw-a-closed-curve-over-a-set-of-points
        */
        d_curva(toolOverride = null) {
            var idx, dStr, dx, dy, n, pts,
                t    = 1/5,
                cPts = [],
                tool = toolOverride ? toolOverride : this.tool;

            if (!tool) { return ''; }

            pts = tool.coords.pts;
            dStr = 'M' + pts[0].x + ' ' + pts[0].y;

            if (pts.length > 2) {
                for (idx = 1; idx < (pts.length - 1); idx++) {
                    dx = pts[idx - 1].x - pts[idx + 1].x;
                    dy = pts[idx - 1].y - pts[idx + 1].y;

                    cPts[idx] = {
                        cPt_pre : {
                            x: pts[idx].x - dx * t,
                            y: pts[idx].y - dy * t,
                        },
                        cPt_pos : {
                            x: pts[idx].x + dx * t,
                            y: pts[idx].y + dy * t,
                        },
                    };
                }

                dStr += ' Q' + cPts[1]['cPt_pos'].x + ' ' + cPts[1]['cPt_pos'].y + ' ' + pts[1].x + ' ' + pts[1].y;  // 1a curva quadratica
                for (idx = 1; idx < (pts.length - 2); idx++) {
                    dStr += ' C' + cPts[idx    ]['cPt_pre'].x + ' ' + cPts[idx    ]['cPt_pre'].y + 
                                ' ' + cPts[idx + 1]['cPt_pos'].x + ' ' + cPts[idx + 1]['cPt_pos'].y + 
                                ' ' + pts[idx + 1].x + ' ' + pts[idx + 1].y;
                }
                n = pts.length - 1                
                dStr += ' Q' + cPts[n - 1]['cPt_pre'].x + ' ' + cPts[n - 1]['cPt_pre'].y + ' ' + pts[n].x + ' ' + pts[n].y;  // ultima curva quadratica

            } else {
                dStr += ' L' + pts[1].x + ' ' + pts[1].y;
            }

            return this.closePath(dStr, false, tool);
        },

        // -----------------------------------------------------------------

        closePath(dStr, forceClose = false, toolOverride = null) {
            var tool = toolOverride ? toolOverride : this.tool;

            return dStr + ((this.closedPath || forceClose) ? ' Z' : '');
        },

        // -----------------------------------------------------------------

        delPts(pM) {
            var i, pA, vMA, vMALen,
                delPts  = [],
                pts     = this.tool.coords.pts,
                delDist = gConsts.tool.metrics.HANDLES_PUSH_DIST/this.GET_waZoomScale;

            for (i = 0; i < pts.length; i++) {
                pA = this.$Victor.fromObject(pts[i]);
                vMA = pA.clone().subtract(pM);
                vMALen = vMA.length();
                if (vMALen < delDist) {
                    if (delPts.length < (pts.length - 3))
                    delPts.push(i);  
                }
            }

            if (delPts.length > 0) {
                evtBus.$emit('evt_toolAction', 'updatePts', { delPts : delPts });
                // this.ACT_toolDelPts({ delPts : delPts });
            }
        },

        // -----------------------------------------------------------------

        pushPts(pM) {
            var i, pA, vMA, vMALen, vMA_, pA_, pB, 
                projM_vAB, vAB, vM_ProjM_vAB, vM_ProjM_vAB_len,
                vMALenMin = 99999,
                newPts    = {},
                pushPts   = {},
                pts       = this.tool.coords.pts,
                pushDist  = gConsts.tool.metrics.HANDLES_PUSH_DIST/this.GET_waZoomScale;

            for (i = 0; i < pts.length; i++) {
                pA = this.$Victor.fromObject(pts[i]);
                vMA = pA.clone().subtract(pM);
                vMALen = vMA.length();
                vMALenMin = Math.min(vMALen, vMALenMin);
                if (vMALen < pushDist) {
                    vMA_ = vMA.clone().normalize().multiply(new this.$Victor(pushDist, pushDist));
                    pA_ = pM.clone().add(vMA_);    
                    pushPts[i] = pA_.toObject();
                }
            }

            // Se nao achou nenhum ponto dentro do circulo da ferramenta
            if (_.isEmpty(pushPts) && (vMALenMin > (pushDist * 1.2))) {
                // Procuro retas que estejam cortando o circulo
                for (i = 0; i < pts.length - 1; i++) {
                    pA  = this.$Victor.fromObject(pts[i]);
                    pB  = this.$Victor.fromObject(pts[i+1]);
                    vAB = pB.clone().subtract(pA);
                    projM_vAB = utils.projP_vAB(pM, pA, vAB);
                    vM_ProjM_vAB = projM_vAB.proj.clone().subtract(pM);
                    vM_ProjM_vAB_len = vM_ProjM_vAB.length();
                    // Se a proj de pM estiver no seg AB e dentro do circulo da ferramenta, crio o ponto
                    if ((vM_ProjM_vAB_len < pushDist) && (projM_vAB.factor > 0) && (projM_vAB.factor < 1)) {
                        newPts[i + 1] = projM_vAB.proj.toObject();  
                    }
                }   
                if (!_.isEmpty(newPts)) {
                    evtBus.$emit('evt_toolAction', 'addPts', { newPts : newPts });
                    // this.ACT_toolAddPts({ tool_id: this.tool.id, newPts : newPts });
                }
            } else {
                evtBus.$emit('evt_toolAction', 'updatePts', { pts : pushPts });
                // this.ACT_toolUpdate({ tool_id: this.tool.id, pts : pushPts });
            }
        },

        // -----------------------------------------------------------------

        mouseDown(evt, pM, toolPt) {
            var pA, pB, vAB, i, distM_vAB,
            handled   = false,             
            minDist   = 99999,
            nearestPt = -1,
            pts       = this.tool.coords.pts,
            newPt     = {};

            this.$parent.mouseDown(evt, pM, toolPt);

            switch (evt.button) {
                case 2 : 
                    if (toolPt != -1) {
                        evtBus.$emit('evt_toolAction', 'updatePts', { delPts : [toolPt] });
                        // this.ACT_toolDelPts({ delPts : [toolPt] })
                    } else {
                        for (i = 0; i < pts.length - 1; i++) {
                            pA  = this.$Victor.fromObject(pts[i]); 
                            pB  = this.$Victor.fromObject(pts[i + 1]); 
                            vAB = pB.clone().subtract(pA);
                            distM_vAB = utils.distP_vAB(pM, pA, pB);
        
                            if ( (distM_vAB != -1    ) &&  // projM se encontra dentro do segmento de reta vAB
                                (distM_vAB < minDist) ) {  // menor distancia aa proj
                                minDist   = distM_vAB;
                                nearestPt = i;
                            }
                        }

                        newPt[nearestPt + 1] = pM;
                        evtBus.$emit('evt_toolAction', 'addPts', { newPts : newPt });
                        // this.ACT_toolAddPts({ tool_id: this.tool.id, newPts : newPt });
                    }
                    handled = true;        
                    break;
            }
            return handled;
        },

        // -----------------------------------------------------------------

        mouseMove(evt, pM, moveType, toolPt) {            
            var pA, pB, vAB, vAM, dist_vBM,
                angle = -1,
                minDist = (gConsts.tool.metrics.CURVE_CREATION_MIN_DIST/this.GET_waZoomScale), 
                maxDist = (gConsts.tool.metrics.CURVE_CREATION_MAX_DIST/this.GET_waZoomScale),
                minAng  = gConsts.tool.metrics.CURVE_CREATION_MIN_ANGLE,
                pts     = this.tool.coords.pts,
                newPt   = {},
                handled = false;

            this.$parent.mouseMove(evt, pM);

            switch (moveType) {
                case gConsts.mov.types.TOOL_CREATION : 
                    if ( (this.$store.state.runtime.mov.dragging) && (evt.button == 0) ) {
                        pB = this.$Victor.fromObject(pts[pts.length - 2]); 
                        dist_vBM = pM.clone().subtract(pB).length();

                        if (pts.length >= 3)  {
                            pA  = this.$Victor.fromObject(pts[pts.length - 3]);
                            vAB = pB.clone().subtract(pA);
                            vAM = pM.clone().subtract(pA);
                            angle = Math.abs(vAB.angleDeg() - vAM.angleDeg());
                        }

                        if ( ( (pts.length == 2) && (dist_vBM > minDist) ) ||
                            (dist_vBM > maxDist                         ) ||
                            ( (dist_vBM > minDist) && (angle > minAng)  ) ) {
                            // console.log('Angle: ' + angle);
                            // console.log('pA: ' + pA);
                            // console.log('pB: ' + pB);
                            // console.log('pA: ' + pM);

                            newPt[pts.length] = pM;
                            evtBus.$emit('evt_toolAction', 'addPts', { newPts : newPt });
                            // this.ACT_toolAddPts({ tool_id: this.tool.id, newPts : newPt })
                            this.ACT_runtimeUpdate({ mov : { toolPt : pts.length - 1 } });

                            if (angle > 10) {
                                console.log('deu biziu :(')
                            }
                        }
                        /* handled vai continuar false pq o mouseMove do medidor ainda tem que 
                           aplicar o delta do movimento no novo ponto */
                    }
                    break;
                
                case gConsts.mov.types.HANDLES_PUSH : 
                case gConsts.mov.types.HANDLES_DEL  : 
                    switch (moveType) {
                        case gConsts.mov.types.HANDLES_PUSH : this.pushPts(pM); break;
                        case gConsts.mov.types.HANDLES_DEL  : this.delPts(pM);  break;
                    }
                    handled = true;
                    break;
            }

            return handled;
        },

        // -----------------------------------------------------------------

    }
}